module.exports = __webpack_public_path__ + "img/text.d7628b27.jpg";